import axios, { AxiosError } from 'axios';
import { queryClient } from '@/lib/queryClient';
import { toast } from 'react-toastify';
import { showError } from '@/lib/alert';
import { STORAGE_KEYS } from '@/utils/storageKeys';

export type ApiErrorResponse = {
  error_code: string
  error_message: string
  validation_errors?: Record<string, string[]>
  trace_id: string
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { 'Content-Type': 'application/json' },
})

let isRedirecting = false

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem(STORAGE_KEYS.AUTH_SESSION)
  if (raw) {
    const session = JSON.parse(raw)
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`
    }
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiErrorResponse>) => {
    const status = error.response?.status

    const apiMessage = error.response?.data?.error_message?.trim() || undefined

    if (status === 401) {
      if (isRedirecting) return Promise.reject(error)
      isRedirecting = true

      localStorage.removeItem(STORAGE_KEYS.AUTH_SESSION)
      queryClient.clear()
      toast.error('Sessão expirada. Por favor, faça login novamente.')
      window.location.pathname = '/'
    } else if (status === 403) {
      if (isRedirecting) return Promise.reject(error)
      isRedirecting = true

      toast.error('Acesso negado. Você não tem permissão para acessar este recurso.')
      window.location.pathname = '/painel/agendas'
    } else if (status !== undefined && status >= 400 && status < 500) {
      const data = error.response?.data
      const isValidationError = data?.error_code === 'VALIDATION_ERROR' && !!data?.validation_errors
      if (!isValidationError) {
        showError(apiMessage ?? 'Dados inválidos. Verifique as informações e tente novamente.')
      }
    } else if (status !== undefined && status >= 500) {
      toast.error(apiMessage ?? 'Erro interno do servidor. Por favor, tente novamente mais tarde.')
    } else if (!error.response) {
      toast.error('Ocorreu um erro inesperado. Por favor, tente novamente.')
    }

    return Promise.reject(error)
  }
)